__turbopack_context__.v({
  "product-placeholder": "_1KKWgq_product-placeholder",
});
